<template>
    <div class="quiz-page">
        <h1>Liste des évaluations créées :</h1>

        <table>
            <tr>
                <th>Nom du quiz</th>
                <th>date</th>
                <th>Aprenant</th>
                <th>Status</th>
                <th>Nombre de triche</th>
                <th>Résultat</th>
            </tr>

            <tr v-for="quiz in evaluations" :key="quiz._id">
                <td>{{ quiz.name }}</td>
                <td>{{ dateToString(quiz.updatedAt) }}</td>
                <td>{{ quiz.learnerName }}</td>
                <td>{{ statusTrad[quiz.status] }}</td>
                <td>{{ quiz.windowQuitingCount }}</td>
                <td>
                    <span class="material-symbols-outlined" v-if="quiz.status == 'finished'"
                        @click="viewResult(quiz._id)">analytics</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            evaluations: [],
            admins: [],
            statusTrad: {
                'in_progress': "En cours",
                'finished': "Terminé",
            }
        }
    },
    methods: {
        async loadEvaluations() {
            const result = await axios.get(this.$store.getters.get_api_url + 'academy/evaluation-created/');
            this.evaluations = result.data.map(evaluation => {
                const learner = this.admins.find(a => a._id == evaluation.personId);
                return {
                    ...evaluation,
                    learnerName: `${learner?.firstname} ${learner?.lastname}`,
                }
            });
        },
        async loadAdmins() {
            const res = await axios.get(this.$store.getters.get_api_url + 'auth/all/');
            this.admins = res.data.filter(admin => admin.is_active);
        },
        viewResult(quizId) {
            this.$router.replace('/academy-result/' + quizId);
        }
    },
    async mounted() {
        await this.loadAdmins();
        this.loadEvaluations();
    }
}
</script>

<style scoped>
.quiz-page {
    padding: 20px;
}

.quiz-page h1 {
    font-size: 28px;
}

table {
    width: 100%;
}

table th,
table td {
    padding: 10px;
    font-size: 12px;
}

table th {
    background-color: #0A1C6B;
    color: white;
}

table td {
    background-color: white;
    text-align: center;
}

table td .material-symbols-outlined {
    margin: 0 5px;
}

table td .material-symbols-outlined:hover {
    cursor: pointer;
    color: #FB984B;
}

table tr td:first-child {
    text-align: left;
}

table tr:first-child th:first-child {
    border-top-left-radius: 10px;
}

table tr:first-child th:last-child {
    border-top-right-radius: 10px;
}

table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}
</style>